import styled from "styled-components"
import { useParams } from "react-router-dom"
import { useSelector } from "react-redux"

import useMotibellDetail from "hooks/motibell/useMotibellDetail"

import Banner from "./Banner"
import ProgressBar from "./ProgressBar"
import ExpiredForm from "./ExpiredForm"
import QuestionForm from "./QuestionForm"
import NotificationBar from "./NotificationBar"
import RewardDescription from "./RewardDescription"
import ImageModal from "components/presenters/modal/ImageModal"
import particleAnimation from "images/lottiefile/particle.json"

export default function MotibellDetail() {
  const { id, isLogin } = useSelector((state) => state.userInfo)
  const { motibellNo } = useParams()
  const {
    getBannerProps,
    getProgressBarProps,
    getQuestionFormProps,
    getExpireFormProps,
    getRewardProps,
    getSubmitFinishModalProps,
    getNotificationBarProps,
  } = useMotibellDetail({
    motibellNo,
    userNo: id,
    showDailyQuiz: true,
    showDailyUserQuiz: true,
  })
  return (
    <ComponentWrapper>
      <Banner {...getBannerProps()} />
      <MidWrapper>
        <ProgressBar
          style={{ marginBottom: "calc(100vw * (12 / 375))" }}
          {...getProgressBarProps()}
        />
        <ExpiredForm {...getExpireFormProps()} />
        <QuestionForm
          {...getQuestionFormProps()}
          style={{ marginBottom: "calc(100vw * (12 / 375))" }}
        />
        {isLogin ? <NotificationBar {...getNotificationBarProps()} /> : null}
      </MidWrapper>
      <RewardDescription {...getRewardProps()} />
      <ImageModal
        lottieOptions={{
          loop: false,
          autoplay: true,
          renderer: "svg",
          animationData: particleAnimation,
        }}
        onComplete={() => () => {
          console.log("a")
        }}
        {...getSubmitFinishModalProps()}
      />
    </ComponentWrapper>
  )
}
const ComponentWrapper = styled.div``

const MidWrapper = styled.div`
  padding: 12.5px calc(100vw * (17 / 375)) 39px;
  background: #fff0bd;
`
